import {
    CLAIMENT_DETAILS_FIELD_SET_VALID,
    CLAIMENT_DETAILS_SET_VALUE,
    FORM_INVALID_TRANSITION_CLAIMENT_DETAILS,
    FORM_VALID_TRANSITION_CLAIMENT_DETAILS,
    RESET_CLAIMENT_DETAILS_FORM,
} from '../../actions/sizotsaFuneralClaim/claimentDetails';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initClaimentDetails = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        claimentType: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        title: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        firstName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        middleName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        lastName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        policyNumber: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        idNumber: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        isPip: {
            displayValue: 'No',
            value: '02',
            error: null,
            status: null,
        },
        relationshipToPolicyHolder: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        streetAddress: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        city: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        district: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        residentialDuration: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },

        dateOfBirth: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        email: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        occupation: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        employer: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        employerPlace: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },

        isAccountHolder: {
            displayValue: 'No',
            value: '02',
            error: null,
            status: null,
        },
        accountHolderId: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        accountHolderName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        bank: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        bankBranch: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        accountNumber: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        accountType: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        idSelected: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        nationality: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        country: {
            displayValue: 'Eswatini',
            value: 'Eswatini',
            error: null,
            status: FORM_STATUS.VALID,
        },
        residenceTimePeriod: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        previousPostalAddress: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        previousPostalCity: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        previousPostalCountry: {
            displayValue: 'Eswatini',
            value: 'Eswatini',
            error: null,
            status: FORM_STATUS.VALID,
        },
        postalSuburb: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        postalCity: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        postalCountry: {
            displayValue: 'Eswatini',
            value: 'Eswatini',
            error: null,
            status: FORM_STATUS.VALID,
        },
        mobileNumber: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        employementType: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        employeeOccupation: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        otherEmployeeOccupation: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        sourceOfIncome: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        otherSourceOfIncome: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        employerPlace: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
        employerName: {
            displayValue: null,
            value: null,
            error: null,
            status: null,
        },
    },
};
// const initialAction={type:"",value:{fieldType:"",value:""}}
export default (state = initClaimentDetails, action) => {
    const trimField = (value) => (value ? value.trim() : value);
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
    switch (action.type) {
        case FORM_VALID_TRANSITION_CLAIMENT_DETAILS:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case FORM_INVALID_TRANSITION_CLAIMENT_DETAILS:
            return { ...state, formStatus: FORM_STATUS.INVALID };
        case CLAIMENT_DETAILS_SET_VALUE:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                displayValue: action.value.displayValue ?? action.value.value,
                value: trimField(action.value.value),
            }));

        case CLAIMENT_DETAILS_FIELD_SET_VALID:
            const { fieldType } = action.value;
            return updateFormField(fieldType, (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case RESET_CLAIMENT_DETAILS_FORM:
            return {
                ...initClaimentDetails,
                form: {
                    ...initClaimentDetails.form,
                    claimentType: { ...state?.form?.claimentType },
                },
            };
        default:
            return state;
        // }
    }
};
